export const api = {
  queryLogList: "bas/security/queryRelieveGuardList.json",
  queryColdStorageList: "bms/queryColdStorage/queryColdStorageList",//查询冷库
  addDeviceRepairRecord: '/bms/device/addDeviceRepairRecord.json', //新增保养
  updateDeviceRepairRecord: 'bms/device/updateDeviceRepairRecord.json', //修改保养
  queryDeviceRepairRecordList: '/bms/device/queryDeviceRepairRecordList.json', //  保养记录
  deleteDeviceRepairRecord: '/bms/device/deleteDeviceRepairRecord.json', //删除保养记录
  statDeviceStatusByStatus: '/bas/firefightoperation/statDeviceStatusByStatus.json', //风机状态
  queryDeviceListByType: '/bms/device/queryDeviceListByType.json', //设备
  queryPersonListApi: '/vas/personnel/queryPersonList.json', //查询员工
  queryAssociationalDeviceTree: '/cms/account/queryAssociationalDeviceTree.json', //区域
  // '/bas/firefightoperation/statDeviceStatusByStatus.json',//风机状态
  statDeviceByColdStorage: '/bas/firefightoperation/statDeviceByColdStorage.json',
  queryFanFaultOperationList: '/bas/firefightoperation/queryFanFaultOperationList.json',
  queryEnergyStatisticsByLastMonth: '/dep/queryEnergy/queryEnergyStatisticsByLastMonth',
  queryEnergyStatisticsByMonth: '/dep/queryEnergy/queryEnergyStatisticsByMonth',
  queryEnergyStatisticsByArea: '/dep/queryEnergy/queryEnergyStatisticsByArea',
  getBuildList: '/bms/energyMeterInfo/getBuildList', // 公用建筑下拉框
  todayConsumption: '/bms/energyMeterDataInfo/todayBuildenergyConsumption', // 今日建筑用电柱状图
  monthBuildenergyConsumption: '/bms/energyMeterDataInfo/monthBuildenergyConsumption',
  yearBuildenergyConsumption: '/bms/energyMeterDataInfo/yearBuildenergyConsumption',
  monthBuildenergyPrediction: '/bms/energyMeterDataInfo/monthBuildenergyPrediction',
  queryEnergyChain: '/bms/energyMeterDataInfo/queryEnergyChain',
  queryEnergyTongBi: '/bms/energyMeterDataInfo/queryEnergyTongBi',

  countWithRunStatus: '/bas/statistics/refrigeration/fan/countWithRunStatus.json',//查询制冷风机运行数量
  runTimeWithDayOfMonth: '/bas/statistics/refrigeration/fan/runTimeWithDayOfMonth.json',//查询风机某天运行时长
  runTimeWithDevice: '/bas/statistics/refrigeration/fan/runTimeWithDevice.json',//查风机运行状态 0 停止 1 运行 2 故障
  runTimeWithHourOfDay: '/bas/statistics/refrigeration/fan/runTimeWithHourOfDay.json',//查询风机某天运行时长
  runTimeWithMonthOfYear: "/bas/statistics/refrigeration/fan/runTimeWithMonthOfYear.json",//查询制冷风机某年各月运行时长

};
